const Textarea = {
  variants: {
    outline: { borderColor: "gray.500", _placeholder: { color: "dark.200" } },
  },
};

export default Textarea;
